var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { HeaderMenuButton } from './menulist/HeaderMenuButton';
import { HeaderMenuIconButton } from './menulist/HeaderMenuIconButton';
import { HeaderMenuList, HeaderMenuListItem, HeaderMenuListItemLink, } from './menulist/HeaderMenuList';
import { HeaderSubMenuButton } from './menulist/HeaderSubMenuButton';
import AppService from '../utils/AppService';
var wwwServerHost = AppService.wwwServerHost();
export var catalogMenuItems = [
    {
        title: '電子・半導体',
        url: "".concat(wwwServerHost, "/catalog/first/1_1/"),
        items: [
            {
                title: '電子・半導体',
                url: "".concat(wwwServerHost, "/catalog/first/1_1/"),
                headline: true,
            },
            { title: '抵抗器', url: "".concat(wwwServerHost, "/catalog/second/2_1/") },
            { title: 'サーミスタ', url: "".concat(wwwServerHost, "/catalog/second/2_2/") },
            { title: 'インダクタ・コイル', url: "".concat(wwwServerHost, "/catalog/second/2_4/") },
            { title: 'コンデンサ', url: "".concat(wwwServerHost, "/catalog/second/2_5/") },
            { title: 'トランス', url: "".concat(wwwServerHost, "/catalog/second/2_6/") },
            { title: '放電ギャップ', url: "".concat(wwwServerHost, "/catalog/second/2_7/") },
            { title: '発振子／共振子', url: "".concat(wwwServerHost, "/catalog/second/2_8/") },
            { title: 'フィルタ', url: "".concat(wwwServerHost, "/catalog/second/2_9/") },
            { title: 'ディレイライン', url: "".concat(wwwServerHost, "/catalog/second/2_10/") },
            { title: 'マイクロ波部品', url: "".concat(wwwServerHost, "/catalog/second/2_11/") },
            { title: '機能回路モジュール', url: "".concat(wwwServerHost, "/catalog/second/2_12/") },
            { title: '銅張積層板', url: "".concat(wwwServerHost, "/catalog/second/2_13/") },
            { title: '光学部品', url: "".concat(wwwServerHost, "/catalog/second/2_14/") },
            { title: '音響部品', url: "".concat(wwwServerHost, "/catalog/second/2_15/") },
            { title: '記録／再生部品', url: "".concat(wwwServerHost, "/catalog/second/2_16/") },
            { title: '振動子', url: "".concat(wwwServerHost, "/catalog/second/2_17/") },
            { title: '記録媒体', url: "".concat(wwwServerHost, "/catalog/second/2_18/") },
            { title: '入出力ユニット', url: "".concat(wwwServerHost, "/catalog/second/2_19/") },
            { title: '記憶ユニット', url: "".concat(wwwServerHost, "/catalog/second/2_20/") },
            {
                title: 'リモートコントロールユニット',
                url: "".concat(wwwServerHost, "/catalog/second/2_21/"),
            },
            { title: '電源', url: "".concat(wwwServerHost, "/catalog/second/2_22/") },
            { title: 'アンテナ', url: "".concat(wwwServerHost, "/catalog/second/2_23/") },
            { title: '高周波部品', url: "".concat(wwwServerHost, "/catalog/second/2_24/") },
            { title: '磁性部品', url: "".concat(wwwServerHost, "/catalog/second/2_25/") },
            { title: '誘電体／絶縁体', url: "".concat(wwwServerHost, "/catalog/second/2_26/") },
            {
                title: '電波吸収・ノイズ抑制材',
                url: "".concat(wwwServerHost, "/catalog/second/2_27/"),
            },
            { title: '電池', url: "".concat(wwwServerHost, "/catalog/second/2_28/") },
            { title: '光源・ランプ', url: "".concat(wwwServerHost, "/catalog/second/2_29/") },
            { title: '水晶デバイス', url: "".concat(wwwServerHost, "/catalog/second/2_30/") },
            { title: 'マイコン', url: "".concat(wwwServerHost, "/catalog/second/2_31/") },
            { title: 'DSP', url: "".concat(wwwServerHost, "/catalog/second/2_32/") },
            { title: 'メモリ', url: "".concat(wwwServerHost, "/catalog/second/2_33/") },
            { title: 'セミカスタムIC', url: "".concat(wwwServerHost, "/catalog/second/2_34/") },
            {
                title: 'プログラマブルロジック',
                url: "".concat(wwwServerHost, "/catalog/second/2_35/"),
            },
            { title: '専用IC', url: "".concat(wwwServerHost, "/catalog/second/2_36/") },
            { title: '汎用ロジックIC', url: "".concat(wwwServerHost, "/catalog/second/2_37/") },
            { title: '汎用リニアIC', url: "".concat(wwwServerHost, "/catalog/second/2_38/") },
            { title: 'GaAsデバイス', url: "".concat(wwwServerHost, "/catalog/second/2_39/") },
            { title: '光半導体', url: "".concat(wwwServerHost, "/catalog/second/2_40/") },
            { title: 'トランジスタ', url: "".concat(wwwServerHost, "/catalog/second/2_41/") },
            { title: 'ダイオード', url: "".concat(wwwServerHost, "/catalog/second/2_42/") },
            { title: '撮像素子', url: "".concat(wwwServerHost, "/catalog/second/2_43/") },
            { title: 'サイリスタ', url: "".concat(wwwServerHost, "/catalog/second/2_44/") },
            {
                title: '複合ディスクリートデバイス',
                url: "".concat(wwwServerHost, "/catalog/second/2_45/"),
            },
            {
                title: 'ディスプレイ・表示デバイス',
                url: "".concat(wwwServerHost, "/catalog/second/2_46/"),
            },
            { title: '蛍光表示管', url: "".concat(wwwServerHost, "/catalog/second/2_47/") },
            { title: 'RFID', url: "".concat(wwwServerHost, "/catalog/second/2_48/") },
            { title: 'LED', url: "".concat(wwwServerHost, "/catalog/second/2_49/") },
            { title: '有機EL', url: "".concat(wwwServerHost, "/catalog/second/2_50/") },
            { title: 'プリント基板', url: "".concat(wwwServerHost, "/catalog/second/2_205/") },
        ],
    },
    {
        title: '機械部品',
        url: "".concat(wwwServerHost, "/catalog/first/1_2/"),
        items: [
            {
                title: '機械部品',
                url: "".concat(wwwServerHost, "/catalog/first/1_2/"),
                headline: true,
            },
            { title: '直動機構・部品', url: "".concat(wwwServerHost, "/catalog/second/2_51/") },
            { title: '軸受・ベアリング', url: "".concat(wwwServerHost, "/catalog/second/2_52/") },
            { title: '伝導部品', url: "".concat(wwwServerHost, "/catalog/second/2_53/") },
            { title: 'ねじ/締結部品', url: "".concat(wwwServerHost, "/catalog/second/2_54/") },
            { title: 'ばね/スプリング', url: "".concat(wwwServerHost, "/catalog/second/2_55/") },
            { title: '制御/吸収', url: "".concat(wwwServerHost, "/catalog/second/2_56/") },
            { title: '密封/シーリング', url: "".concat(wwwServerHost, "/catalog/second/2_57/") },
            { title: '配管部品', url: "".concat(wwwServerHost, "/catalog/second/2_58/") },
            { title: '給油装置', url: "".concat(wwwServerHost, "/catalog/second/2_59/") },
            { title: 'ロール（ローラー）', url: "".concat(wwwServerHost, "/catalog/second/2_60/") },
            { title: 'ブラシ', url: "".concat(wwwServerHost, "/catalog/second/2_61/") },
            { title: 'スプレーノズル', url: "".concat(wwwServerHost, "/catalog/second/2_62/") },
            { title: 'ステージ', url: "".concat(wwwServerHost, "/catalog/second/2_63/") },
            { title: '治具', url: "".concat(wwwServerHost, "/catalog/second/2_64/") },
            { title: '筐体/キャビネット', url: "".concat(wwwServerHost, "/catalog/second/2_65/") },
            { title: '真空ポンプ/真空部品', url: "".concat(wwwServerHost, "/catalog/second/2_66/") },
            { title: '空圧用部品', url: "".concat(wwwServerHost, "/catalog/second/2_67/") },
            { title: '機構部品', url: "".concat(wwwServerHost, "/catalog/second/2_202/") },
        ],
    },
    {
        title: '製造加工機',
        url: "".concat(wwwServerHost, "/catalog/first/1_3/"),
        items: [
            {
                title: '製造加工機',
                url: "".concat(wwwServerHost, "/catalog/first/1_3/"),
                headline: true,
            },
            { title: '工作機械', url: "".concat(wwwServerHost, "/catalog/second/2_68/") },
            { title: '加工機械', url: "".concat(wwwServerHost, "/catalog/second/2_69/") },
            { title: '溶接機械', url: "".concat(wwwServerHost, "/catalog/second/2_70/") },
            { title: '塗装機械', url: "".concat(wwwServerHost, "/catalog/second/2_71/") },
            { title: '真空装置', url: "".concat(wwwServerHost, "/catalog/second/2_72/") },
            { title: '熱処理・工業炉', url: "".concat(wwwServerHost, "/catalog/second/2_73/") },
            { title: '加熱機器・ヒータ', url: "".concat(wwwServerHost, "/catalog/second/2_74/") },
            { title: '乾燥装置', url: "".concat(wwwServerHost, "/catalog/second/2_75/") },
            { title: '粉粒体機械', url: "".concat(wwwServerHost, "/catalog/second/2_76/") },
            { title: '洗浄装置', url: "".concat(wwwServerHost, "/catalog/second/2_77/") },
            { title: '分離・ろ過装置', url: "".concat(wwwServerHost, "/catalog/second/2_78/") },
            { title: '撹拌・混合機器', url: "".concat(wwwServerHost, "/catalog/second/2_79/") },
            { title: '純水製造装置', url: "".concat(wwwServerHost, "/catalog/second/2_80/") },
            { title: '蒸留/精製/濃縮装置', url: "".concat(wwwServerHost, "/catalog/second/2_81/") },
            { title: '滅菌/殺菌/消毒機器', url: "".concat(wwwServerHost, "/catalog/second/2_82/") },
            { title: 'ガス発生装置', url: "".concat(wwwServerHost, "/catalog/second/2_83/") },
            { title: '包装機械', url: "".concat(wwwServerHost, "/catalog/second/2_84/") },
            { title: '運搬機械・荷役機械', url: "".concat(wwwServerHost, "/catalog/second/2_85/") },
            { title: '搬送装置', url: "".concat(wwwServerHost, "/catalog/second/2_86/") },
            { title: '保管・貯蔵', url: "".concat(wwwServerHost, "/catalog/second/2_87/") },
            { title: 'マーキング/印字', url: "".concat(wwwServerHost, "/catalog/second/2_88/") },
            { title: '産業機械', url: "".concat(wwwServerHost, "/catalog/second/2_89/") },
            { title: 'ポンプ', url: "".concat(wwwServerHost, "/catalog/second/2_90/") },
            { title: '空圧機器', url: "".concat(wwwServerHost, "/catalog/second/2_91/") },
            { title: '油圧機器', url: "".concat(wwwServerHost, "/catalog/second/2_92/") },
            { title: '産業用ロボット', url: "".concat(wwwServerHost, "/catalog/second/2_93/") },
            { title: '基板実装機', url: "".concat(wwwServerHost, "/catalog/second/2_94/") },
            { title: '半導体製造装置', url: "".concat(wwwServerHost, "/catalog/second/2_95/") },
            { title: '樹脂・フィルム加工機', url: "".concat(wwwServerHost, "/catalog/second/2_96/") },
            { title: '食品飲料機械', url: "".concat(wwwServerHost, "/catalog/second/2_97/") },
            { title: '医薬品製造機械', url: "".concat(wwwServerHost, "/catalog/second/2_98/") },
            { title: '木工機械', url: "".concat(wwwServerHost, "/catalog/second/2_99/") },
            { title: '繊維機械', url: "".concat(wwwServerHost, "/catalog/second/2_100/") },
            { title: '紙・印刷機械', url: "".concat(wwwServerHost, "/catalog/second/2_101/") },
            { title: '建設機械', url: "".concat(wwwServerHost, "/catalog/second/2_102/") },
            { title: '3Dプリンタ', url: "".concat(wwwServerHost, "/catalog/second/2_201/") },
            { title: '冷却機器', url: "".concat(wwwServerHost, "/catalog/second/2_209/") },
        ],
    },
    {
        title: '電機・制御',
        url: "".concat(wwwServerHost, "/catalog/first/1_4/"),
        items: [
            {
                title: '電機・制御',
                url: "".concat(wwwServerHost, "/catalog/first/1_4/"),
                headline: true,
            },
            { title: 'PLC/コントローラ', url: "".concat(wwwServerHost, "/catalog/second/2_103/") },
            { title: '表示灯/信号灯', url: "".concat(wwwServerHost, "/catalog/second/2_104/") },
            { title: 'センサ', url: "".concat(wwwServerHost, "/catalog/second/2_105/") },
            { title: 'スイッチ', url: "".concat(wwwServerHost, "/catalog/second/2_106/") },
            { title: '操作スイッチ', url: "".concat(wwwServerHost, "/catalog/second/2_107/") },
            { title: '検出スイッチ', url: "".concat(wwwServerHost, "/catalog/second/2_108/") },
            { title: 'リレー', url: "".concat(wwwServerHost, "/catalog/second/2_109/") },
            { title: 'ヒューズ・遮断器', url: "".concat(wwwServerHost, "/catalog/second/2_110/") },
            { title: '安全機器', url: "".concat(wwwServerHost, "/catalog/second/2_111/") },
            { title: 'モータ', url: "".concat(wwwServerHost, "/catalog/second/2_112/") },
            { title: 'アクチュエータ', url: "".concat(wwwServerHost, "/catalog/second/2_113/") },
            { title: '減速機', url: "".concat(wwwServerHost, "/catalog/second/2_114/") },
            {
                title: 'マシンビジョン/画像処理',
                url: "".concat(wwwServerHost, "/catalog/second/2_115/"),
            },
            { title: '自動認識/RFID', url: "".concat(wwwServerHost, "/catalog/second/2_116/") },
            { title: 'コンタクタ', url: "".concat(wwwServerHost, "/catalog/second/2_117/") },
            { title: '記録計/データロガー', url: "".concat(wwwServerHost, "/catalog/second/2_118/") },
            { title: 'ネットワーク機器', url: "".concat(wwwServerHost, "/catalog/second/2_119/") },
            { title: '静電気対策機器', url: "".concat(wwwServerHost, "/catalog/second/2_120/") },
            { title: '電力保護機器', url: "".concat(wwwServerHost, "/catalog/second/2_121/") },
            { title: 'コネクタ', url: "".concat(wwwServerHost, "/catalog/second/2_122/") },
            { title: 'プラグ／ジャック', url: "".concat(wwwServerHost, "/catalog/second/2_123/") },
            { title: 'ソケット', url: "".concat(wwwServerHost, "/catalog/second/2_124/") },
            { title: '電線・ケーブル', url: "".concat(wwwServerHost, "/catalog/second/2_125/") },
            { title: '圧着端子', url: "".concat(wwwServerHost, "/catalog/second/2_126/") },
            { title: '端子台', url: "".concat(wwwServerHost, "/catalog/second/2_127/") },
            { title: 'DINレール', url: "".concat(wwwServerHost, "/catalog/second/2_128/") },
            { title: 'その他電機・制御', url: "".concat(wwwServerHost, "/catalog/second/2_129/") },
        ],
    },
    {
        title: '測定・試験・検査',
        url: "".concat(wwwServerHost, "/catalog/first/1_5/"),
        items: [
            {
                title: '測定・試験・検査',
                url: "".concat(wwwServerHost, "/catalog/first/1_5/"),
                headline: true,
            },
            { title: '試験機', url: "".concat(wwwServerHost, "/catalog/second/2_130/") },
            { title: '計測/測定器', url: "".concat(wwwServerHost, "/catalog/second/2_131/") },
            { title: '流量計測/測定器', url: "".concat(wwwServerHost, "/catalog/second/2_132/") },
            {
                title: '電気・磁気計測/測定器',
                url: "".concat(wwwServerHost, "/catalog/second/2_133/"),
            },
            { title: '検査装置', url: "".concat(wwwServerHost, "/catalog/second/2_134/") },
            { title: '校正機器', url: "".concat(wwwServerHost, "/catalog/second/2_206/") },
        ],
    },
    {
        title: '理化学機器',
        url: "".concat(wwwServerHost, "/catalog/first/1_6/"),
        items: [
            {
                title: '理化学機器',
                url: "".concat(wwwServerHost, "/catalog/first/1_6/"),
                headline: true,
            },
            { title: '加熱/冷却機器', url: "".concat(wwwServerHost, "/catalog/second/2_135/") },
            { title: '恒温器・恒温槽', url: "".concat(wwwServerHost, "/catalog/second/2_136/") },
            { title: '分注装置', url: "".concat(wwwServerHost, "/catalog/second/2_137/") },
            { title: '反応装置', url: "".concat(wwwServerHost, "/catalog/second/2_138/") },
            { title: '培養装置', url: "".concat(wwwServerHost, "/catalog/second/2_139/") },
            { title: '濃縮装置', url: "".concat(wwwServerHost, "/catalog/second/2_140/") },
            { title: '冷凍・冷蔵保管', url: "".concat(wwwServerHost, "/catalog/second/2_141/") },
            {
                title: '顕微鏡/マイクロスコープ',
                url: "".concat(wwwServerHost, "/catalog/second/2_142/"),
            },
            { title: '分析装置', url: "".concat(wwwServerHost, "/catalog/second/2_143/") },
            { title: '実験用品', url: "".concat(wwwServerHost, "/catalog/second/2_144/") },
            { title: '実験・作業台', url: "".concat(wwwServerHost, "/catalog/second/2_145/") },
            { title: '収納棚・薬品庫', url: "".concat(wwwServerHost, "/catalog/second/2_146/") },
        ],
    },
    {
        title: '素材・材料',
        url: "".concat(wwwServerHost, "/catalog/first/1_7/"),
        items: [
            {
                title: '素材・材料',
                url: "".concat(wwwServerHost, "/catalog/first/1_7/"),
                headline: true,
            },
            { title: '鉄鋼/ステンレス/合金', url: "".concat(wwwServerHost, "/catalog/second/2_147/") },
            { title: '非鉄金属', url: "".concat(wwwServerHost, "/catalog/second/2_148/") },
            { title: '金属材料', url: "".concat(wwwServerHost, "/catalog/second/2_149/") },
            { title: '高分子材料', url: "".concat(wwwServerHost, "/catalog/second/2_150/") },
            { title: '紙・パルプ', url: "".concat(wwwServerHost, "/catalog/second/2_151/") },
            { title: '有機天然材料', url: "".concat(wwwServerHost, "/catalog/second/2_152/") },
            { title: '薬品', url: "".concat(wwwServerHost, "/catalog/second/2_153/") },
            { title: 'プラスチック', url: "".concat(wwwServerHost, "/catalog/second/2_154/") },
            {
                title: 'エンプラ/スーパーエンプラ',
                url: "".concat(wwwServerHost, "/catalog/second/2_155/"),
            },
            { title: 'ゴム', url: "".concat(wwwServerHost, "/catalog/second/2_156/") },
            { title: 'セラミックス', url: "".concat(wwwServerHost, "/catalog/second/2_157/") },
            { title: '発泡樹脂・スポンジ', url: "".concat(wwwServerHost, "/catalog/second/2_158/") },
            { title: '磁石', url: "".concat(wwwServerHost, "/catalog/second/2_159/") },
            { title: '化学繊維', url: "".concat(wwwServerHost, "/catalog/second/2_160/") },
            { title: '天然繊維', url: "".concat(wwwServerHost, "/catalog/second/2_161/") },
            { title: 'ガラス', url: "".concat(wwwServerHost, "/catalog/second/2_163/") },
            { title: '木材', url: "".concat(wwwServerHost, "/catalog/second/2_164/") },
            { title: '半導体材料', url: "".concat(wwwServerHost, "/catalog/second/2_208/") },
        ],
    },
    {
        title: 'IT・ソフト',
        url: "".concat(wwwServerHost, "/catalog/first/1_8/"),
        items: [
            {
                title: 'IT・ソフト',
                url: "".concat(wwwServerHost, "/catalog/first/1_8/"),
                headline: true,
            },
            { title: '試験・検査ソフト', url: "".concat(wwwServerHost, "/catalog/second/2_165/") },
            { title: '工作機械用ソフト', url: "".concat(wwwServerHost, "/catalog/second/2_166/") },
            { title: 'PLM', url: "".concat(wwwServerHost, "/catalog/second/2_167/") },
            { title: 'CAD', url: "".concat(wwwServerHost, "/catalog/second/2_168/") },
            { title: 'CAE/解析ソフト', url: "".concat(wwwServerHost, "/catalog/second/2_169/") },
            { title: 'SCM', url: "".concat(wwwServerHost, "/catalog/second/2_170/") },
            { title: 'MES', url: "".concat(wwwServerHost, "/catalog/second/2_171/") },
            { title: 'CRM', url: "".concat(wwwServerHost, "/catalog/second/2_172/") },
            { title: 'SCADA', url: "".concat(wwwServerHost, "/catalog/second/2_210/") },
            { title: '生産スケジューラ', url: "".concat(wwwServerHost, "/catalog/second/2_173/") },
            { title: 'ERP', url: "".concat(wwwServerHost, "/catalog/second/2_174/") },
            { title: '基幹系システム', url: "".concat(wwwServerHost, "/catalog/second/2_175/") },
            { title: '情報システム', url: "".concat(wwwServerHost, "/catalog/second/2_176/") },
            {
                title: '情報共有/コミュニケーション',
                url: "".concat(wwwServerHost, "/catalog/second/2_177/"),
            },
            { title: 'PC/オフィスソフト', url: "".concat(wwwServerHost, "/catalog/second/2_178/") },
            { title: 'メールソフト', url: "".concat(wwwServerHost, "/catalog/second/2_179/") },
            { title: 'セキュリティ', url: "".concat(wwwServerHost, "/catalog/second/2_180/") },
            { title: 'データ分析', url: "".concat(wwwServerHost, "/catalog/second/2_181/") },
            { title: '通信・ネットワーク', url: "".concat(wwwServerHost, "/catalog/second/2_182/") },
            { title: '開発支援ツール', url: "".concat(wwwServerHost, "/catalog/second/2_204/") },
            { title: 'ミドルウェア', url: "".concat(wwwServerHost, "/catalog/second/2_207/") },
        ],
    },
    {
        title: '設備・消耗品・その他',
        url: "".concat(wwwServerHost, "/catalog/first/1_9/"),
        items: [
            {
                title: '設備・消耗品・その他',
                url: "".concat(wwwServerHost, "/catalog/first/1_9/"),
                headline: true,
            },
            { title: '給排水設備', url: "".concat(wwwServerHost, "/catalog/second/2_183/") },
            { title: 'エネルギー設備', url: "".concat(wwwServerHost, "/catalog/second/2_184/") },
            { title: '水処理装置', url: "".concat(wwwServerHost, "/catalog/second/2_185/") },
            { title: '熱源設備', url: "".concat(wwwServerHost, "/catalog/second/2_186/") },
            { title: '空調設備', url: "".concat(wwwServerHost, "/catalog/second/2_187/") },
            { title: 'セキュリティ設備', url: "".concat(wwwServerHost, "/catalog/second/2_188/") },
            { title: '消防/防災設備', url: "".concat(wwwServerHost, "/catalog/second/2_189/") },
            { title: '環境設備', url: "".concat(wwwServerHost, "/catalog/second/2_190/") },
            {
                title: '物流・マテハン・ロジスティクス',
                url: "".concat(wwwServerHost, "/catalog/second/2_191/"),
            },
            { title: 'クリーンルーム', url: "".concat(wwwServerHost, "/catalog/second/2_192/") },
            { title: '安全用品', url: "".concat(wwwServerHost, "/catalog/second/2_193/") },
            { title: '工具・測量器具', url: "".concat(wwwServerHost, "/catalog/second/2_194/") },
            { title: 'MRO', url: "".concat(wwwServerHost, "/catalog/second/2_195/") },
            { title: '備品', url: "".concat(wwwServerHost, "/catalog/second/2_196/") },
            { title: 'サービス/コンサル', url: "".concat(wwwServerHost, "/catalog/second/2_197/") },
            {
                title: 'セミナー/トレーニング',
                url: "".concat(wwwServerHost, "/catalog/second/2_198/"),
            },
            { title: 'その他', url: "".concat(wwwServerHost, "/catalog/second/2_199/") },
            { title: 'OA機器', url: "".concat(wwwServerHost, "/catalog/second/2_200/") },
            {
                title: 'システム・ソリューション',
                url: "".concat(wwwServerHost, "/catalog/second/2_203/"),
            },
        ],
    },
];
export function CatalogCategoryButton() {
    var _a = useState(false), isActive = _a[0], setIsActive = _a[1];
    return (_jsx(HeaderMenuButton, __assign({ width: 239, button: function () { return (_jsx("div", __assign({ onMouseEnter: function () { return setIsActive(true); }, onMouseLeave: function () { return setIsActive(false); } }, { children: _jsx(HeaderMenuIconButton, { isActive: isActive, label: "\u30AB\u30BF\u30ED\u30B0\u5206\u985E", icon: "".concat(AppService.staticServerHost(), "/common/images/header/menu.svg"), iconHover: "".concat(AppService.staticServerHost(), "/common/images/header/menu_red.svg") }) }))); }, interactionType: "click" }, { children: _jsx(HeaderMenuList, { children: catalogMenuItems.map(function (item) {
                if (item.items) {
                    return (_jsx(HeaderSubMenuButton, __assign({ button: _jsx(HeaderMenuListItemLink, { item: item }) }, { children: _jsx(HeaderMenuList, __assign({ grid: true }, { children: item.items.map(function (_item) { return (_jsx(HeaderMenuListItem, { item: _item }, "".concat(_item.title))); }) })) }), "".concat(item.title)));
                }
                return _jsx(HeaderMenuListItem, { item: item }, "".concat(item.title));
            }) }) })));
}
